// generated with /tools/importSvg.js
export const twoLayers = 'm2 14.5 10 5 10-5m-10-10-10 5 10 5 10-5z';
export const threeLayers = 'm2 17 10 5 10-5M2 12l10 5 10-5M12 2 2 7l10 5 10-5z';
export const activity = 'M22 12h-4l-3 9L9 3l-3 9H2';
export const airplay = 'M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1m-7-2 5 6H7z';
export const alertCircle = 'M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const alertOctagon = 'M12 8v4m0 4h.01M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86z';
export const alertTriangle =
    'M12 8v4m0 4h.01M10.29 2.86 1.82 17a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 2.86a2 2 0 0 0-3.42 0';
export const alignCenter = 'M18 10H6m15-4H3m18 8H3m15 4H6';
export const alignJustify = 'M21 10H3m18-4H3m18 8H3m18 4H3';
export const alignLeft = 'M17 10H3m18-4H3m18 8H3m14 4H3';
export const alignRight = 'M21 10H7m14-4H3m18 8H3m18 4H7';
export const anchor = 'M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v14m0 0A10 10 0 0 1 2 12h3m7 10a10 10 0 0 0 10-10h-3';
export const aperture =
    'm14.31 8 5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16 3.95 6.06M14.31 16H2.83m13.79-4-5.74 9.94M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const archive = 'M21 8v13H3V8m7 4h4M1 3h22v5H1z';
export const arrowDownCircle =
    'm8 12 4 4m0 0 4-4m-4 4V8m10 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const arrowDownLeft = 'M17 7 7 17m0 0h10M7 17V7';
export const arrowDownRight = 'm7 7 10 10m0 0V7m0 10H7';
export const arrowDown = 'M12 5v14m0 0 7-7m-7 7-7-7';
export const arrowLeftCircle =
    'm12 8-4 4m0 0 4 4m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const arrowLeft = 'M19 12H5m0 0 7 7m-7-7 7-7';
export const arrowRightCircle =
    'm12 16 4-4m0 0-4-4m4 4H8m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const arrowRight = 'M5 12h14m0 0-7-7m7 7-7 7';
export const arrowUpCircle =
    'm16 12-4-4m0 0-4 4m4-4v8m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const arrowUpLeft = 'M17 17 7 7m0 0v10M7 7h10';
export const arrowUpRight = 'M7 17 17 7m0 0H7m10 0v10';
export const arrowUp = 'M12 19V5m0 0-7 7m7-7 7 7';
export const atSign = 'M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const award = 'M8.21 13.89 7 23l5-3 5 3-1.21-9.12M19 8A7 7 0 1 1 5 8a7 7 0 0 1 14 0';
export const barChart2 = 'M18 20V10m-6 10V4M6 20v-6';
export const barChart = 'M12 20V10m6 10V4M6 20v-4';
export const batteryCharging =
    'M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19M23 13v-2M11 6l-4 6h6l-4 6';
export const battery = 'M23 13v-2M3 6h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2';
export const bellNotification =
    'M12 2a6 6 0 0 0-6 6c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936-.475-.764-.924-1.742-1.233-2.976M9.354 21c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1';
export const bellOff =
    'M13.73 21a2 2 0 0 1-3.46 0m8.36-8A17.9 17.9 0 0 1 18 8a6 6 0 0 0-9.33-5M6.26 6.26A5.9 5.9 0 0 0 6 8c0 7-3 9-3 9h14M1 1l22 22';
export const bell =
    'M9.354 21c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8';
export const bluetooth = 'm6.5 6.5 11 11L12 23V1l5.5 5.5-11 11';
export const bold = 'M6 12h8a4 4 0 1 0 0-8H6zm0 0h9a4 4 0 1 1 0 8H6z';
export const bookOpen = 'M12 7a4 4 0 0 0-4-4H2v15h7a3 3 0 0 1 3 3m0-14v14m0-14a4 4 0 0 1 4-4h6v15h-7a3 3 0 0 0-3 3';
export const book = 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5A2.5 2.5 0 0 0 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5z';
export const bookmark = 'm19 21-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z';
export const box =
    'M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12m9 4V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16';
export const briefcase =
    'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16M4 7h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2';
export const calendar = 'M16 2v4M8 2v4m-5 4h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2';
export const cameraOff =
    'm1 1 22 22M9 3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3z';
export const camera = 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z';
export const cast =
    'M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6M2 20h.01';
export const checkCircle = 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3';
export const checkSquare = 'm9 11 3 3L22 4m-1 8v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11';
export const check = 'M20 6 9 17l-5-5';
export const chevronDown = 'm6 9 6 6 6-6';
export const chevronLeft = 'm15 18-6-6 6-6';
export const chevronRight = 'm9 18 6-6-6-6';
export const chevronUp = 'm18 15-6-6-6 6';
export const chevronsDown = 'm7 13 5 5 5-5M7 6l5 5 5-5';
export const chevronsLeft = 'm11 17-5-5 5-5m7 10-5-5 5-5';
export const chevronsRight = 'm13 17 5-5-5-5M6 17l5-5-5-5';
export const chevronsUp = 'm17 11-5-5-5 5m10 7-5-5-5 5';
export const chrome =
    'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 0h9.17M3.95 6.06 8.54 14m2.34 7.94L15.46 14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const circle = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const clipboardCheck =
    'M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 11 2 2 4.5-4.5M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6';
export const clipboard =
    'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m1-2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1';
export const clock = 'M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const cloudDrizzle = 'M8 19v2m0-8v2m8 4v2m0-8v2m-4 6v2m0-8v2m8-.42A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25';
export const cloudLightning = 'M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9M13 11l-4 6h6l-4 6';
export const cloudOff =
    'M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3M1 1l22 22';
export const cloudRain = 'M16 13v8m-8-8v8m4-6v8m8-6.42A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25';
export const cloudSnow =
    'M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01';
export const cloud = 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10';
export const code = 'm16 18 6-6-6-6M8 6l-6 6 6 6';
export const codepen =
    'm12 2 10 6.5M12 2 2 8.5M12 2v6.5m10 0v7m0-7-10 7m10 0L12 22m10-6.5-10-7M12 22 2 15.5M12 22v-6.5m-10 0v-7m0 7 10-7m-10 0 10 7';
export const codesandbox =
    'm7.5 4.21 4.5 2.6 4.5-2.6m-9 15.58V14.6L3 12m18 0-4.5 2.6v5.19M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12m9 4V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16';
export const coffee = 'M18 8h1a4 4 0 1 1 0 8h-1m0-8H2v9a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4zM6 1v3m4-3v3m4-3v3';
export const coinStack =
    'M14.176 4.222C14.176 2.994 11.673 2 8.587 2S3.002 2.996 3 4.222m0 0C3 5.45 5.501 6.444 8.588 6.444s5.589-.994 5.589-2.222v8.623M3 4.222v13.334c.001 1.227 2.502 2.222 5.588 2.222 1.497 0 2.848-.237 3.85-.618M3.002 8.667c0 1.228 2.501 2.222 5.588 2.222s5.589-.994 5.589-2.222m-1.672 6.028c-1.008.394-2.391.639-3.918.639-3.086 0-5.587-.995-5.587-2.223m17.526.354a4.98 4.98 0 0 1 0 7.07 5.05 5.05 0 0 1-7.113 0 4.98 4.98 0 0 1 0-7.07 5.05 5.05 0 0 1 7.113 0';
export const coins =
    'M9.422 4.158a7.368 7.368 0 1 1 10.42 10.42m-3.105.053A7.369 7.369 0 1 1 2 14.63a7.369 7.369 0 0 1 14.738 0';
export const collapse =
    'M10.36 5.017h11.157M10.36 18.983h11.157m-18.813-7.03h18.813M5.657 8.675l-3.1 3.1a.25.25 0 0 0 0 .353l3.1 3.1';
export const columns = 'M12 3v18m0-18h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7zm0 0H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7z';
export const command = 'M18 3a3 3 0 0 0-3 3v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 0 0 0-6';
export const compass = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const copy =
    'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1m-4 4h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2';
export const cornerDownLeft = 'm9 10-5 5m0 0 5 5m-5-5h12a4 4 0 0 0 4-4V4';
export const cornerDownRight = 'm15 10 5 5m0 0-5 5m5-5H8a4 4 0 0 1-4-4V4';
export const cornerLeftDown = 'm14 15-5 5m0 0-5-5m5 5V8a4 4 0 0 1 4-4h7';
export const cornerLeftUp = 'M14 9 9 4m0 0L4 9m5-5v12a4 4 0 0 0 4 4h7';
export const cornerRightDown = 'm10 15 5 5m0 0 5-5m-5 5V8a4 4 0 0 0-4-4H4';
export const cornerRightUp = 'm10 9 5-5m0 0 5 5m-5-5v12a4 4 0 0 1-4 4H4';
export const cornerUpLeft = 'M9 14 4 9m0 0 5-5M4 9h12a4 4 0 0 1 4 4v7';
export const cornerUpRight = 'm15 14 5-5m0 0-5-5m5 5H8a4 4 0 0 0-4 4v7';
export const cpu =
    'M9 1v3m6-3v3M9 20v3m6-3v3m5-14h3m-3 5h3M1 9h3m-3 5h3M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m3 5h6v6H9z';
export const creditCard = 'M1 10h22M3 4h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2';
export const crop = 'M6.13 1 6 16a2 2 0 0 0 2 2h15M1 6.13 16 6a2 2 0 0 1 2 2v15';
export const crosshair =
    'M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10h-4m-6 10C6.477 22 2 17.523 2 12m10 10v-4M2 12C2 6.477 6.477 2 12 2M2 12h4m6-10v4';
export const database =
    'M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 7c0 1.66-4 3-9 3s-9-1.34-9-3';
export const dataflow =
    'M4 18v-.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 13 7.12 13 8.8 13h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 15.28 20 16.12 20 17.8v.2M4 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4m16 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 0V8M6 8h12c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 6.398 21 5.932 21 5s0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 2 18.932 2 18 2H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 3.602 3 4.068 3 5s0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 8 5.068 8 6 8';
export const backspace = 'm18 9-6 6m0-6 6 6m3-11H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2';
export const disc = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const divideCircle = 'M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const divideSquare = 'M8 12h8M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const divide = 'M5 12h14m-5-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0';
export const dollarSign = 'M12 1v22m5-18H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6';
export const downloadCloud = 'm8 17 4 4m0 0 4-4m-4 4v-9m8.88 6.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29';
export const download = 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4m4-5 5 5m0 0 5-5m-5 5V3';
export const drag =
    'M7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M17 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M17 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M17 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2';
export const dribble =
    'M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const droplet = 'm12 2.69 5.66 5.66a8 8 0 1 1-11.31 0z';
export const edit2 = 'M17 3a2.827 2.827 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z';
export const edit3 = 'M12 20h9M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4z';
export const edit =
    'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4z';
export const expand =
    'M2.512 5.017h11.156M2.512 18.983h11.156m-11.157-7.03h18.814m-3.01-3.277 3.1 3.1a.25.25 0 0 1 0 .353l-3.1 3.1';
export const externalLink = 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6m4-3h6m0 0v6m0-6L10 14';
export const eyeOff =
    'M9.9 4.24A9 9 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22m-5.06-5.06A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94z';
export const eye = 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8';
export const facebook = 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z';
export const fastForward = 'm13 19 9-7-9-7zM2 19l9-7-9-7z';
export const feather = 'M16 8 2 22m15.5-7H9m11.24-2.76a6.003 6.003 0 0 0-8.49-8.49L5 10.5V19h8.5z';
export const figma =
    'M12 2H8.5a3.5 3.5 0 1 0 0 7M12 2v7m0-7h3.5a3.5 3.5 0 1 1 0 7M12 9H8.5M12 9h3.5M12 9v7M8.5 9a3.5 3.5 0 0 0 0 7m7-7a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-7 7a3.5 3.5 0 1 0 3.5 3.5V16m-3.5 0H12';
export const fileMinus = 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-6-6 6 6m-6-6v6h6M9 15h6';
export const filePlus = 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-6-6 6 6m-6-6v6h6m-8 10v-6m-3 3h6';
export const fileText =
    'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-6-6 6 6m-6-6v6h6m-4 5H8m8 4H8m2-8H8';
export const file = 'M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-7-7 7 7m-7-7v7h7';
export const film =
    'M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5m10 0h5M17 7h5M4.18 2h15.64A2.18 2.18 0 0 1 22 4.18v15.64A2.18 2.18 0 0 1 19.82 22H4.18A2.18 2.18 0 0 1 2 19.82V4.18A2.18 2.18 0 0 1 4.18 2';
export const filter = 'M22 3H2l8 9.46V19l4 2v-8.54z';
export const filtersLines = 'M6 12h12M3 6h18M9 18h6';
export const flag = 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zm0 0v7';
export const folderMinus = 'M9 14h6m7 5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z';
export const folderPlus = 'M12 11v6m-3-3h6m7 5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z';
export const folder = 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z';
export const framer = 'M5 16h7m-7 0V9h14V2H5l14 14H5m0 0 7 7v-7z';
export const frown =
    'M16 16s-1.5-2-4-2-4 2-4 2m1-7h.01M15 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const gift =
    'M20 12v10H4V12m8 10V7m0 0H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7m0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7M2 7h20v5H2z';
export const gitBranch =
    'M6 3v12m0 0a3 3 0 1 0 3 3m-3-3a3 3 0 0 1 3 3m9-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0a9 9 0 0 1-9 9';
export const gitCommit = 'M1.05 12H7m10.01 0h5.95M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const gitMerge = 'M15 18a3 3 0 1 0 6 0 3 3 0 0 0-6 0m0 0a9 9 0 0 1-9-9m0 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12';
export const gitPullRequest =
    'M18 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 0V8a2 2 0 0 0-2-2h-3M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12';
export const github =
    'M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.4 13.4 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22';
export const gitlab =
    'M22.65 14.39 12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.43.43 0 0 1 5.4 2a.4.4 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51a.43.43 0 0 1 .69-.16.4.4 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94';
export const globe =
    'M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10H2m10 10C6.477 22 2 17.523 2 12m10 10a15.3 15.3 0 0 0 4-10 15.3 15.3 0 0 0-4-10m0 20a15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10M2 12C2 6.477 6.477 2 12 2';
export const grid = 'M10 3H3v7h7zM21 3h-7v7h7zM21 14h-7v7h7zM10 14H3v7h7z';
export const hardDrive =
    'M22 12H2m20 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6m20 0-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11L2 12m4 4h.01M10 16h.01';
export const hash = 'M4 9h16M4 15h16M10 3 8 21m8-18-2 18';
export const headphones =
    'M3 18v-6a9 9 0 1 1 18 0v6m0 1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z';
export const heart =
    'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.501 5.501 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78';
export const helpCircle =
    'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const hexagon =
    'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16';
export const home = 'M9 22V12h6v10M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z';
export const image =
    'M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2m0 0 11-11 5 5M10 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0';
export const inbox =
    'M22 12h-6l-2 3h-4l-2-3H2m20 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6m20 0-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11L2 12';
export const info = 'M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const instagram =
    'M17.5 6.5h.01M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5m9 9.37a4 4 0 1 1-7.914 1.174A4 4 0 0 1 16 11.37';
export const italic = 'M19 4h-9m4 16H5M15 4 9 20';
export const key =
    'M15.5 7.5 19 4m2-2-2 2zm-9.61 9.61a5.501 5.501 0 0 1-3.881 9.415 5.5 5.5 0 0 1-3.897-1.637 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5zM15.5 7.5l3 3L22 7l-3-3z';
export const layout = 'M3 9h18M9 21V9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const lifeBuoy =
    'm4.93 4.93 4.24 4.24m5.66 5.66 4.24 4.24m0-14.14-4.24 4.24 3.53-3.53M4.93 19.07l4.24-4.24M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const link2 = 'M9 17H6A5 5 0 1 1 6 7h3m-1 5h8m-1-5h3a5 5 0 1 1 0 10h-3z';
export const link =
    'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71';
export const linkedin =
    'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6M6 9H2v12h4zM4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4';
export const list = 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01';
export const loader =
    'M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48 2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48 2.83-2.83';
export const lock = 'M7 11V7a5 5 0 1 1 10 0v4M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2';
export const logIn = 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4m-5-4 5-5m0 0-5-5m5 5H3';
export const logOut = 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m7 14 5-5m0 0-5-5m5 5H9';
export const mail = 'M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6m20 0-10 7L2 6';
export const mapPin = 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0';
export const map = 'm8 18-7 4V6l7-4m0 16 8 4m-8-4V2m8 20 7-4V2l-7 4m0 16V6m0 0L8 2';
export const maximize2 = 'M15 3h6m0 0v6m0-6-7 7M9 21H3m0 0v-6m0 6 7-7';
export const maximize = 'M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3';
export const meh = 'M8 15h8M9 9h.01M15 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const menu2 = 'M3 12h14M3 6h18M3 18h18';
export const menu = 'M3 12h18M3 6h18M3 18h18';
export const messageCircle =
    'M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z';
export const messageSquare = 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z';
export const micOff =
    'm1 1 22 22M15 9.34V4a3 3 0 0 0-5.94-.6M17 16.95A7 7 0 0 1 5 12v-2m14 0v2q0 .62-.11 1.23M12 19v4m-4 0h8M9 9v3a3 3 0 0 0 5.12 2.12z';
export const mic =
    'M19 10v2a7 7 0 0 1-7 7m0 0a7 7 0 0 1-7-7v-2m7 9v4m-4 0h8M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3';
export const minimize2 = 'M4 14h6m0 0v6m0-6-7 7m17-11h-6m0 0V4m0 6 7-7';
export const minimize = 'M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3';
export const minusCircle = 'M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const minusSquare = 'M8 12h8M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const minus = 'M5 12h14';
export const monitor = 'M8 21h8m-4-4v4M4 3h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const moon = 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79';
export const moreHorizontal =
    'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2';
export const moreVertical =
    'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2';
export const mousePointer = 'm13 13 6 6M3 3l7.07 16.97 2.51-7.39 7.39-2.51z';
export const move = 'm5 9-3 3m0 0 3 3m-3-3h20M9 5l3-3m0 0 3 3m-3-3v20m3-3-3 3m0 0-3-3M19 9l3 3m0 0-3 3';
export const music = 'M9 18V5l12-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0m12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0';
export const navigation2 = 'm12 2 7 19-7-4-7 4z';
export const navigation = 'm3 11 19-9-9 19-2-8z';
export const octagon = 'M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86z';
export const packet =
    'm16.5 9.4-9-5.19M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12m9 4V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16';
export const paperclip =
    'm21.44 11.05-9.19 9.19a6.003 6.003 0 1 1-8.49-8.49l9.19-9.19a4.002 4.002 0 0 1 5.66 5.66l-9.2 9.19a2.001 2.001 0 1 1-2.83-2.83l8.49-8.48';
export const pauseCircle = 'M10 15V9m4 6V9m8 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const pause = 'M10 4H6v16h4zM18 4h-4v16h4z';
export const penTool =
    'm2 2 14.5 3.5L18 13l-5 5-7.5-1.5zm0 0 7.586 7.586M12 19l7-7 3 3-7 7zm1-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0';
export const percent = 'M19 5 5 19M9 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m11 11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0';
export const phoneCall =
    'M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const phoneForwarded =
    'm19 1 4 4m0 0-4 4m4-4h-8m7 11.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const phoneIncoming =
    'M16 2v6m0 0h6m-6 0 7-7m-1 15.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const phoneMissed =
    'm23 1-6 6m0-6 6 6m-1 9.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const phoneOff =
    'M5.19 12.81a19.8 19.8 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91M23 1 1 23m9.68-9.69a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.4 19.4 0 0 1-3.33-2.67z';
export const phoneOutgoing =
    'M23 7V1m0 0h-6m6 0-7 7m6 8.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const phone =
    'M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92';
export const pieChart = 'M21.21 15.89A10 10 0 1 1 8 2.83M22 12A10 10 0 0 0 12 2v10z';
export const playCircle = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const play = 'm5 3 14 9-14 9z';
export const plusCircle = 'M12 8v8m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const plusSquare = 'M12 8v8m-4-4h8M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const plus = 'M12 5v14m-7-7h14';
export const pocket = 'm8 10 4 4 4-4M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-20 0V5a2 2 0 0 1 2-2';
export const power = 'M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10';
export const printer =
    'M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z';
export const radio =
    'M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0';
export const refreshCcw =
    'M1 4v6m0 0h6m-6 0 4.64-4.36A9 9 0 0 1 20.49 9M23 20v-6m0 0h-6m6 0-4.64 4.36A9 9 0 0 1 3.51 15';
export const refreshCw =
    'M23 4v6m0 0h-6m6 0-4.64-4.36A9 9 0 0 0 3.51 9M1 20v-6m0 0h6m-6 0 4.64 4.36A9 9 0 0 0 20.49 15';
export const repeat = 'm17 1 4 4m0 0-4 4m4-4H7a4 4 0 0 0-4 4v2m4 12-4-4m0 0 4-4m-4 4h14a4 4 0 0 0 4-4v-2';
export const rewind = 'm11 19-9-7 9-7zM22 19l-9-7 9-7z';
export const rfidBox =
    'M9.163 5.284H7.02c-1.637 0-2.456 0-3.08.319-.55.28-.998.727-1.278 1.277-.319.625-.319 1.444-.319 3.081v7.21c0 1.637 0 2.455.319 3.08.28.55.727.998 1.277 1.278.625.319 1.444.319 3.08.319h7.21c1.638 0 2.456 0 3.081-.32.55-.28.998-.726 1.278-1.276.318-.626.318-1.444.318-3.081v-2.144m-7.17-2.655.004.004m10.165-1.905a8.82 8.82 0 0 0-2.59-5.677 8.82 8.82 0 0 0-5.678-2.59m-.636 3.343a6.07 6.07 0 0 1 3.787 1.773 6.07 6.07 0 0 1 1.773 3.788m-3.352.621a3.3 3.3 0 0 0-.947-1.883 3.3 3.3 0 0 0-1.914-.95';
export const rifdSignal =
    'M16.243 5.757a6 6 0 0 1 0 8.486m-8.486 0a6 6 0 0 1 0-8.486M4.93 17.071c-3.906-3.905-3.906-10.237 0-14.142m14.142 0c3.906 3.905 3.906 10.237 0 14.142M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0v9';
export const rocket =
    'M13.325 10.675 5.44 18.56m.85-5.722-3.861-.912a.558.558 0 0 1-.267-.936l3.071-3.072c.207-.206.486-.324.78-.326l3.462-.03m4.362-3.963a25 25 0 0 1 6.564 6.564m-9.24 7.547.912 3.861c.1.425.627.575.936.267l3.071-3.071c.207-.207.325-.486.327-.78l.03-3.462m4.625-6.174.9-4.336a1.672 1.672 0 0 0-1.977-1.978l-4.336.901a6.7 6.7 0 0 0-3.369 1.82L8.724 8.313a8.93 8.93 0 0 0-2.52 5.016l-.012.082a3.877 3.877 0 0 0 4.397 4.396l.082-.013a8.92 8.92 0 0 0 5.016-2.519l3.556-3.556a6.7 6.7 0 0 0 1.82-3.369';
export const rotateCcw = 'M1 4v6m0 0h6m-6 0 4.64-4.36A9 9 0 1 1 3.51 15';
export const rotateCw = 'M23 4v6m0 0h-6m6 0-4.63-4.36A9 9 0 1 0 20.49 15';
export const rss = 'M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16M6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0';
export const save = 'M17 21v-8H7v8M7 3v5h8m4 13H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2';
export const scissors =
    'M20 4 8.12 15.88m6.35-1.4L20 20M8.12 8.12 12 12M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0';
export const search = 'm21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0';
export const send = 'M22 2 11 13M22 2l-7 20-4-9M22 2 2 9l9 4';
export const server =
    'M6 6h.01M6 18h.01M4 2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 12h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2';
export const settings =
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7.4 0a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 3.417 1.415 2 2 0 0 1-.587 1.415l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1';
export const share2 =
    'm8.59 13.51 6.83 3.98m-.01-10.98-6.82 3.98M21 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0m12 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0';
export const share = 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8m-4-6-4-4m0 0L8 6m4-4v13';
export const shieldOff =
    'M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18M4.73 4.73 4 5v7c0 6 8 10 8 10a20.3 20.3 0 0 0 5.62-4.38M1 1l22 22';
export const shieldZap =
    'm13 7.5-3 3 4 2-3 3m9-3.5c0 4.909-5.354 8.479-7.302 9.615-.221.13-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.479 4 16.909 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.242.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.422 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543z';
export const shield = 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10';
export const shoppingBag = 'm3 6 3-4h12l3 4M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6M3 6h18m-5 4a4 4 0 1 1-8 0';
export const shoppingCart =
    'M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6m4 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0';
export const shuffle = 'M16 3h5m0 0v5m0-5L4 20m17-4v5m0 0h-5m5 0-6-6M4 4l5 5';
export const sidebar = 'M9 3v18M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const skipBack = 'M5 19V5m14 15L9 12l10-8z';
export const skipForward = 'M19 5v14M5 4l10 8-10 8z';
export const slack =
    'M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5';
export const slashDivider = 'm7.516 22.171 9.298-19.939';
export const slash = 'm4.93 4.93 14.14 14.14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const sliders01 = 'M3 8h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0m-6 8h12M9 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0';
export const sliders02 = 'M4 21v-7m0-4V3m8 18v-9m0-4V3m8 18v-5m0-4V3M1 14h6m2-6h6m2 8h6';
export const smartphone = 'M12 18h.01M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2';
export const smile =
    'M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const speaker =
    'M12 6h.01M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m10 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const square = 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2';
export const star = 'm12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z';
export const stopCircle = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const storageBox =
    'M20.5 8v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.22 21 17.38 21 15.7 21H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 18.72 3.5 17.88 3.5 16.2V8m.1-5h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v1.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 8 20.96 8 20.4 8H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 7.24 2 6.96 2 6.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3m6 8.5h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 12.26 16 12.54 16 13.1v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 14.74 8 14.46 8 13.9v-.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 11.5 9.04 11.5 9.6 11.5';
export const sun =
    'M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72 1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0';
export const sunrise =
    'M17 18a5 5 0 1 0-10 0m5-16v7m0-7L8 6m4-4 4 4M4.22 10.22l1.42 1.42M1 18h2m18 0h2m-4.64-6.36 1.42-1.42M23 22H1';
export const sunset =
    'M17 18a5 5 0 1 0-10 0m5-9V2m0 7 4-4m-4 4L8 5m-3.78 5.22 1.42 1.42M1 18h2m18 0h2m-4.64-6.36 1.42-1.42M23 22H1';
export const switchHorizontal01 = 'M20 17H4m0 0 4-4m-4 4 4 4M4 7h16m0 0-4-4m4 4-4 4';
export const tablet = 'M12 18h.01M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2';
export const tag = 'M7.5 7.5h.01m13.58 6.41-7.17 7.17a2 2 0 0 1-2.83 0L2.5 12.5v-10h10l8.59 8.59a2 2 0 0 1 0 2.82';
export const target = 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10';
export const terminal = 'm4 17 6-6-6-6m8 14h8';
export const thermometer = 'M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0';
export const thumbsDown =
    'M17 2h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17m-7 2v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3z';
export const thumbsUp =
    'M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m7-2V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3z';
export const toggleLeft = 'M16 5H8a7 7 0 0 0 0 14h8a7 7 0 1 0 0-14';
export const toggleRight = 'M16 5H8a7 7 0 0 0 0 14h8a7 7 0 1 0 0-14';
export const tool =
    'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.121 2.121 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z';
export const trash2 =
    'M3 6h2m0 0h16M5 6v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6zm3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-6 5v6m4-6v6';
export const trash = 'M3 6h2m0 0h16M5 6v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6zm3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2';
export const trello = 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2';
export const trendingDown = 'm23 18-9.5-9.5-5 5L1 6m22 12h-6m6 0v-6';
export const trendingUp = 'm23 6-9.5 9.5-5-5L1 18M23 6h-6m6 0v6';
export const triangle = 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0';
export const truck =
    'M16 16V3H1v13zm0 0h7v-5l-3-3h-4zm-8 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m13 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0';
export const tv = 'm17 2-5 5-5-5M4 7h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2';
export const twitch = 'M16 11V7m5-5H3v16h5v4l4-4h5l4-4zm-10 9V7z';
export const twitter =
    'M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5q-.001-.419-.08-.83A7.7 7.7 0 0 0 23 3';
export const type = 'M4 7V4h16v3M9 20h6M12 4v16';
export const umbrella = 'M18 19a3 3 0 0 1-6 0v-7m11 0a11.05 11.05 0 0 0-22 0z';
export const underline = 'M6 3v7a6 6 0 1 0 12 0V3M4 21h16';
export const unlock = 'M7 11V7a5 5 0 0 1 9.9-1M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2';
export const uploadCloud = 'm16 16-4-4m0 0-4 4m4-4v9m8.39-2.61A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3';
export const upload = 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4m14-7-5-5m0 0L7 8m5-5v12';
export const userCheck = 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2m16-10 2 2 4-4M12.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const userMinus = 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2m22-10h-6m-4.5-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const userPlus = 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M20 8v6m3-3h-6m-4.5-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const userX = 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M18 8l5 5m0-5-5 5m-5.5-6a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const user = 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const users =
    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2m22 0v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0';
export const videoOff =
    'M10.66 5H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22m-7-7v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2z';
export const video = 'm23 7-7 5 7 5zM14 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2';
export const voicemail = 'M5.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0 0h13m0 0a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9';
export const volume1 = 'M15.54 8.46a5 5 0 0 1 0 7.07M11 5 6 9H2v6h4l5 4z';
export const volume2 = 'M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07M11 5 6 9H2v6h4l5 4z';
export const volumeX = 'm23 9-6 6m0-6 6 6M11 5 6 9H2v6h4l5 4z';
export const volume = 'M11 5 6 9H2v6h4l5 4z';
export const watch =
    'M12 9v3l1.5 1.5m3.01 3.85-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0';
export const wifiOff =
    'm1 1 22 22m-6.28-11.94c.82.4 1.585.9 2.28 1.49m-14 0a10.94 10.94 0 0 1 5.17-2.39m.54-5.11A16 16 0 0 1 22.58 9M1.42 9a15.9 15.9 0 0 1 4.7-2.88m2.41 9.99a6 6 0 0 1 6.95 0M12 20h.01';
export const wifi = 'M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01';
export const wind = 'M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2';
export const xCircle = 'm15 9-6 6m0-6 6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10';
export const xOctagon = 'm15 9-6 6m0-6 6 6M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86z';
export const xSquare = 'm9 9 6 6m0-6-6 6M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2';
export const x = 'M18 6 6 18M6 6l12 12';
export const youtube =
    'M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2c.312-1.732.466-3.49.46-5.25a29 29 0 0 0-.46-5.33';
export const zapOff = 'M12.41 6.75 13 2l-2.43 2.92m8 7.99L21 10h-5.34M8 8l-5 6h9l-1 8 5-6M1 1l22 22';
export const zap = 'M13 2 3 14h9l-1 8 10-12h-9z';
export const zoomIn = 'm21 21-4.35-4.35M11 8v6m-3-3h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0';
export const zoomOut = 'm21 21-4.35-4.35M8 11h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0';

export default {
    '2-layers': twoLayers,
    '3-layers': threeLayers,
    activity: activity,
    airplay: airplay,
    'alert-circle': alertCircle,
    'alert-octagon': alertOctagon,
    'alert-triangle': alertTriangle,
    'align-center': alignCenter,
    'align-justify': alignJustify,
    'align-left': alignLeft,
    'align-right': alignRight,
    anchor: anchor,
    aperture: aperture,
    archive: archive,
    'arrow-down-circle': arrowDownCircle,
    'arrow-down-left': arrowDownLeft,
    'arrow-down-right': arrowDownRight,
    'arrow-down': arrowDown,
    'arrow-left-circle': arrowLeftCircle,
    'arrow-left': arrowLeft,
    'arrow-right-circle': arrowRightCircle,
    'arrow-right': arrowRight,
    'arrow-up-circle': arrowUpCircle,
    'arrow-up-left': arrowUpLeft,
    'arrow-up-right': arrowUpRight,
    'arrow-up': arrowUp,
    'at-sign': atSign,
    award: award,
    'bar-chart-2': barChart2,
    'bar-chart': barChart,
    'battery-charging': batteryCharging,
    battery: battery,
    'bell-notification': bellNotification,
    'bell-off': bellOff,
    bell: bell,
    bluetooth: bluetooth,
    bold: bold,
    'book-open': bookOpen,
    book: book,
    bookmark: bookmark,
    box: box,
    briefcase: briefcase,
    calendar: calendar,
    'camera-off': cameraOff,
    camera: camera,
    cast: cast,
    'check-circle': checkCircle,
    'check-square': checkSquare,
    check: check,
    'chevron-down': chevronDown,
    'chevron-left': chevronLeft,
    'chevron-right': chevronRight,
    'chevron-up': chevronUp,
    'chevrons-down': chevronsDown,
    'chevrons-left': chevronsLeft,
    'chevrons-right': chevronsRight,
    'chevrons-up': chevronsUp,
    chrome: chrome,
    circle: circle,
    'clipboard-check': clipboardCheck,
    clipboard: clipboard,
    clock: clock,
    'cloud-drizzle': cloudDrizzle,
    'cloud-lightning': cloudLightning,
    'cloud-off': cloudOff,
    'cloud-rain': cloudRain,
    'cloud-snow': cloudSnow,
    cloud: cloud,
    code: code,
    codepen: codepen,
    codesandbox: codesandbox,
    coffee: coffee,
    'coin-stack': coinStack,
    coins: coins,
    collapse: collapse,
    columns: columns,
    command: command,
    compass: compass,
    copy: copy,
    'corner-down-left': cornerDownLeft,
    'corner-down-right': cornerDownRight,
    'corner-left-down': cornerLeftDown,
    'corner-left-up': cornerLeftUp,
    'corner-right-down': cornerRightDown,
    'corner-right-up': cornerRightUp,
    'corner-up-left': cornerUpLeft,
    'corner-up-right': cornerUpRight,
    cpu: cpu,
    'credit-card': creditCard,
    crop: crop,
    crosshair: crosshair,
    database: database,
    dataflow: dataflow,
    backspace: backspace,
    disc: disc,
    'divide-circle': divideCircle,
    'divide-square': divideSquare,
    divide: divide,
    'dollar-sign': dollarSign,
    'download-cloud': downloadCloud,
    download: download,
    drag: drag,
    dribble: dribble,
    droplet: droplet,
    'edit-2': edit2,
    'edit-3': edit3,
    edit: edit,
    expand: expand,
    'external-link': externalLink,
    'eye-off': eyeOff,
    eye: eye,
    facebook: facebook,
    'fast-forward': fastForward,
    feather: feather,
    figma: figma,
    'file-minus': fileMinus,
    'file-plus': filePlus,
    'file-text': fileText,
    file: file,
    film: film,
    filter: filter,
    'filters-lines': filtersLines,
    flag: flag,
    'folder-minus': folderMinus,
    'folder-plus': folderPlus,
    folder: folder,
    framer: framer,
    frown: frown,
    gift: gift,
    'git-branch': gitBranch,
    'git-commit': gitCommit,
    'git-merge': gitMerge,
    'git-pull-request': gitPullRequest,
    github: github,
    gitlab: gitlab,
    globe: globe,
    grid: grid,
    'hard-drive': hardDrive,
    hash: hash,
    headphones: headphones,
    heart: heart,
    'help-circle': helpCircle,
    hexagon: hexagon,
    home: home,
    image: image,
    inbox: inbox,
    info: info,
    instagram: instagram,
    italic: italic,
    key: key,
    layout: layout,
    'life-buoy': lifeBuoy,
    'link-2': link2,
    link: link,
    linkedin: linkedin,
    list: list,
    loader: loader,
    lock: lock,
    'log-in': logIn,
    'log-out': logOut,
    mail: mail,
    'map-pin': mapPin,
    map: map,
    'maximize-2': maximize2,
    maximize: maximize,
    meh: meh,
    'menu-2': menu2,
    menu: menu,
    'message-circle': messageCircle,
    'message-square': messageSquare,
    'mic-off': micOff,
    mic: mic,
    'minimize-2': minimize2,
    minimize: minimize,
    'minus-circle': minusCircle,
    'minus-square': minusSquare,
    minus: minus,
    monitor: monitor,
    moon: moon,
    'more-horizontal': moreHorizontal,
    'more-vertical': moreVertical,
    'mouse-pointer': mousePointer,
    move: move,
    music: music,
    'navigation-2': navigation2,
    navigation: navigation,
    octagon: octagon,
    packet: packet,
    paperclip: paperclip,
    'pause-circle': pauseCircle,
    pause: pause,
    'pen-tool': penTool,
    percent: percent,
    'phone-call': phoneCall,
    'phone-forwarded': phoneForwarded,
    'phone-incoming': phoneIncoming,
    'phone-missed': phoneMissed,
    'phone-off': phoneOff,
    'phone-outgoing': phoneOutgoing,
    phone: phone,
    'pie-chart': pieChart,
    'play-circle': playCircle,
    play: play,
    'plus-circle': plusCircle,
    'plus-square': plusSquare,
    plus: plus,
    pocket: pocket,
    power: power,
    printer: printer,
    radio: radio,
    'refresh-ccw': refreshCcw,
    'refresh-cw': refreshCw,
    repeat: repeat,
    rewind: rewind,
    'rfid-box': rfidBox,
    'rifd-signal': rifdSignal,
    rocket: rocket,
    'rotate-ccw': rotateCcw,
    'rotate-cw': rotateCw,
    rss: rss,
    save: save,
    scissors: scissors,
    search: search,
    send: send,
    server: server,
    settings: settings,
    'share-2': share2,
    share: share,
    'shield-off': shieldOff,
    'shield-zap': shieldZap,
    shield: shield,
    'shopping-bag': shoppingBag,
    'shopping-cart': shoppingCart,
    shuffle: shuffle,
    sidebar: sidebar,
    'skip-back': skipBack,
    'skip-forward': skipForward,
    slack: slack,
    'slash-divider': slashDivider,
    slash: slash,
    'sliders-01': sliders01,
    'sliders-02': sliders02,
    smartphone: smartphone,
    smile: smile,
    speaker: speaker,
    square: square,
    star: star,
    'stop-circle': stopCircle,
    'storage-box': storageBox,
    sun: sun,
    sunrise: sunrise,
    sunset: sunset,
    'switch-horizontal-01': switchHorizontal01,
    tablet: tablet,
    tag: tag,
    target: target,
    terminal: terminal,
    thermometer: thermometer,
    'thumbs-down': thumbsDown,
    'thumbs-up': thumbsUp,
    'toggle-left': toggleLeft,
    'toggle-right': toggleRight,
    tool: tool,
    'trash-2': trash2,
    trash: trash,
    trello: trello,
    'trending-down': trendingDown,
    'trending-up': trendingUp,
    triangle: triangle,
    truck: truck,
    tv: tv,
    twitch: twitch,
    twitter: twitter,
    type: type,
    umbrella: umbrella,
    underline: underline,
    unlock: unlock,
    'upload-cloud': uploadCloud,
    upload: upload,
    'user-check': userCheck,
    'user-minus': userMinus,
    'user-plus': userPlus,
    'user-x': userX,
    user: user,
    users: users,
    'video-off': videoOff,
    video: video,
    voicemail: voicemail,
    'volume-1': volume1,
    'volume-2': volume2,
    'volume-x': volumeX,
    volume: volume,
    watch: watch,
    'wifi-off': wifiOff,
    wifi: wifi,
    wind: wind,
    'x-circle': xCircle,
    'x-octagon': xOctagon,
    'x-square': xSquare,
    x: x,
    youtube: youtube,
    'zap-off': zapOff,
    zap: zap,
    'zoom-in': zoomIn,
    'zoom-out': zoomOut
};
